var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"spinner"}},[_c('h1',[_vm._v("Loading data...")]),_c('semipolar-spinner',{attrs:{"animation-duration":1500,"size":400,"color":"#c8102e"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }